import React, {useMemo} from 'react'

import {Link} from '../../link'
import {Buttonv2 as Button} from '../../v2'
import AuthorizedUser from './AutorizedUser'
import {DEFAULT_AVATAR_ID, DEFAULT_SERVICE, MAX_USERS_BEFORE_SCROLL} from './consts'
import {PassportContext} from './context'
import {PassportUserContext, PassportUserData, PassportUserProps} from './types'
import {getPassportLocalization} from './utils'

const PassportUser: React.FC<PassportUserProps> = ({
  avatarHost,
  accounts,
  defaultUid,
  passportHost,
  className,
  returnPath,
  yui,
  canAddMore,
  mobile,
  cameraUrl,
  maxDisplayedUsers = MAX_USERS_BEFORE_SCROLL,
  service = DEFAULT_SERVICE,
  locale,
}) => {
  const users: PassportUserData[] = useMemo(
    () =>
      (accounts || []).map(account => ({
        login: account.displayName.name,
        id: account.uid,
        email: account.defaultEmail,
        avatarId: account.displayName.default_avatar,
      })),
    [accounts],
  )
  const isAuthorized = useMemo(() => !!users.length, [users])
  const defaultUser: PassportUserData = isAuthorized
    ? (defaultUid && users.find(item => item.id === defaultUid)) || users[0]
    : users[0]
  const localeData = getPassportLocalization(locale)
  const passportContext = useMemo<PassportUserContext>(
    () => ({
      defaultUid,
      avatarHost,
      avatarUrl: `${avatarHost}/get-yapic/${defaultUser?.avatarId ?? DEFAULT_AVATAR_ID}`,
      passportHost,
      returnPath,
      yui,
      maxDisplayedUsers,
      cameraUrl: cameraUrl || `${passportHost}/profile/public`,
      className,
      mobile,
      signoutHref: `${passportHost}/passport?mode=logout&retpath=${returnPath}&yu=${yui}`,
      addUserHref: `${passportHost}/auth?mode=add-user&retpath=${returnPath}`,
      authHref: isAuthorized ? passportHost : `${passportHost}/auth/?retpath=${returnPath}&from=${service}`,
      service,
      canAddMore,
      locale: localeData,
    }),
    [
      avatarHost,
      cameraUrl,
      canAddMore,
      className,
      defaultUid,
      defaultUser?.avatarId,
      isAuthorized,
      localeData,
      maxDisplayedUsers,
      mobile,
      passportHost,
      returnPath,
      service,
      yui,
    ],
  )

  return (
    <PassportContext.Provider value={passportContext}>
      <div className={className}>
        {isAuthorized ? (
          <AuthorizedUser defaultUser={defaultUser} users={users} />
        ) : (
          <Button aria-label={localeData.signin} Component={Link} href={passportContext.authHref}>
            {localeData.signin}
          </Button>
        )}
      </div>
    </PassportContext.Provider>
  )
}

export default PassportUser
